module.exports = __webpack_public_path__ + "media/images/email-54c247c1fc65e5eac2e9cb166774c111.svg";